export default {
  APP_ID: 'smartforms',
  DEFAULT_LIST_LIMIT: 20,
  APPLICATION_NS: 'APPLICATION',
  FORMS_NS: 'FORMS',
  FORM_INSTANCES_NS: 'FORM_INSTANCES',
};
